import React, { useEffect, useState } from "react";

import {
  Marker,
  GoogleMap,
  withScriptjs,
  withGoogleMap,
  // DirectionsRenderer,
} from "react-google-maps";

function Map({ locationList }) {
  const {
    InfoBox,
  } = require("react-google-maps/lib/components/addons/InfoBox");
  const location = locationList;

  const [selectedLocation, setSelectedLocation] = useState(null);

  const [props, setProps] = useState({
    lat: 6.465422,
    lng: 3.406448,
  });

  useEffect(() => {
    if (location?.location) {
      const lat = location?.location?.coords?.latitude;
      const lng = location?.location?.coords?.longitude;

      setProps((p) => ({
        ...p,
        lat: lat,
        lng: lng,
      }));
    }
  }, [location]);


  return (
    <>
      <GoogleMap
        zoom={props?.lat && props?.lng ? 17 : 6}
        center={{
          lat: typeof props?.lat === 'number' ? props.lat : 6.465422,
          lng: typeof props?.lng === 'number' ? props.lng : 3.406448,
        }}
      >
        {location.location && (
          <Marker
            position={{
              lat: location?.location?.coords?.latitude,
              lng: location?.location?.coords?.longitude,
            }}
            onChange={() => { }}
            onClick={() => {
              setSelectedLocation(location.location);
            }}
          />
        )}

        {selectedLocation && (
          <InfoBox
            position={{
              lat: selectedLocation.coords.latitude,
              lng: selectedLocation.coords.longitude,
            }}
            onCloseClick={() => {
              setSelectedLocation(null);
            }}
          >
            <div className="info-box">
              <div className="info-text">
                <p>Courier Name: {selectedLocation.courier_name}</p>
                <p>Status: {selectedLocation.status}</p>
                <p>
                  Pending Orders:
                  {selectedLocation.order_status.order_pending}
                </p>
                <p>
                  Accepted Orders:
                  {selectedLocation.order_status.order_accepted}
                </p>
              </div>
            </div>
          </InfoBox>
        )}
      </GoogleMap>
    </>
  );
}

const WrappedMap = withScriptjs(withGoogleMap(Map));

export default function RidersMap({ locationList }) {
  const google_key = process.env.REACT_APP_GOOGLE_WEB_API_KEY;
  return (
    <div style={{ height: "100vh", width: "100%" }}>
      <WrappedMap
        locationList={locationList}
        googleMapURL={`https://maps.googleapis.com/maps/api/js?v=3.exp&libraries=geometry,drawing,places&key=${google_key}`}
        loadingElement={<div style={{ height: "100%" }} />}
        containerElement={<div style={{ height: "700px" }} />}
        mapElement={<div style={{ height: "100vh" }} />}
      />
    </div>
  );
}
